<script>
import Layout from "../../layouts/main";
import AdminClientProfile from "@/components/adminClientProfile";
import AdminClientOffersBoard from "@/components/adminClientOffersBoard";
import AdminClientSettings from "@/components/adminClientSettings";
import AdminClientContentBoard from "@/components/adminClientContentBoard";
import AdminClientCampaigns from "@/components/adminClientCampaigns";
import axios from "axios";

export default {
  components: {
    AdminClientContentBoard,
    AdminClientSettings,
    AdminClientOffersBoard,
    AdminClientProfile,
    AdminClientCampaigns,
    Layout,
  },
  async created() {
    this.$store.commit('loader/START_LOADING');
    try {
      const {data} = await axios.get(`/admin/client/${this.clientId}/profile`);
      this.client = data;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  computed: {
    clientId() {
      return this.$route.params.clientId;
    },
    currentTab() {
      return this.$route.params.tab;
    }
  },
  data() {
    return {
      client: null,
    }
  },
  methods: {
    setTab(tabName) {
      if (this.currentTab === tabName) {
        return
      }
      this.$router.push(`/admin/clients/${this.clientId}/${tabName}`)
    }
  },
}
</script>

<template>
  <Layout>

    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div class="row" v-if="client">
              <div class="col-md-12">
                <h4 class="font-weight-bold">{{ client.company_name }}</h4>
              </div>
            </div>
            <b-tabs nav-class="nav-tabs-custom" content-class="text-muted">
              <b-tab :active="!currentTab || currentTab === 'profile' " @click.prevent="setTab('profile')" class="pt-4">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar-alt"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Profile</span>
                </template>

                <div>
                  <admin-client-profile v-if="client" :client.sync="client"></admin-client-profile>
                </div>
              </b-tab>
              <b-tab :active="currentTab === 'settings' " @click.prevent="setTab('settings')" class="pt-4">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar-alt"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Settings</span>
                </template>

                <div>
<!--                  Leave `currentTab === 'settings'` because slider inside admin-client-settings has a bag if it is created before it is actualy shown-->
                  <admin-client-settings v-if="client && currentTab === 'settings'" :client.sync="client"></admin-client-settings>
                </div>
              </b-tab>
              <b-tab :active="currentTab === 'campaigns' " @click.prevent="setTab('campaigns')" class="pt-4">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar-alt"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Campaigns</span>
                </template>

                <div>
                  <admin-client-campaigns :client-id="clientId"></admin-client-campaigns>
                </div>
              </b-tab>
              <b-tab :active="currentTab === 'offers-board' " @click.prevent="setTab('offers-board')" class="pt-4">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar-alt"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Offers Board</span>
                </template>

                <div>
                  <admin-client-offers-board></admin-client-offers-board>
                </div>
              </b-tab>
              <b-tab :active="currentTab === 'content-board' " @click.prevent="setTab('content-board')" class="pt-4">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar-alt"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Content Board</span>
                </template>

                <div>
                  <admin-client-content-board></admin-client-content-board>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>

</style>
